import { questionsService } from '../services/questions.service';
import { PendingQuestion } from '../types/questions.types';
import { useCatalogueSection, type CatalogueSectionService } from './useCatalogueSection';

const CATALOGUE_QUESTIONS_PAGE_SIZE = 5;

const catalogueQuestionService: CatalogueSectionService<'questionId', string, PendingQuestion> = {
  itemIdName: 'questionId',
  pageSize: CATALOGUE_QUESTIONS_PAGE_SIZE,
  itemsLabel: 'question',
  fetchPage: async (cursor) => await questionsService.getAllQuestions(cursor, CATALOGUE_QUESTIONS_PAGE_SIZE),
  approveItem: async (questionId, versionId) => await questionsService.approveQuestion(questionId, versionId),
  rejectItem: async (questionId, versionId) => await questionsService.declineQuestion(questionId, versionId),
  bulkApproveItems: async (infos) => await questionsService.bulkApproveQuestions(infos),
}

export const useCatalogueQuestions = () => {
  const { items, approveItem, rejectItem, approveAllItems, loading, pagination } = useCatalogueSection(
    catalogueQuestionService
  )

  return {
    questions: items,
    approveQuestion: approveItem,
    declineQuestion: rejectItem,
    bulkApproveQuestions: approveAllItems,
    loading,
    pagination
  }
};
